import type { FunnelQuery, StepSeries } from '@hotjar/dashboard-quantz';
import type { ContextOfUse, DateRange } from '@hotjar/global-filters';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { KnownReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import { FunnelSteps } from './FunnelSteps';
import { GlobalFilterSection } from './GlobalFilterSection';

interface QuerySectionProps {
  currentFunnelQuery: FunnelQuery;
  stepsWithError: string[];
  showReducedUi: boolean;
  setCurrentFunnelQuery: (newFunnelQuery: FunnelQuery) => void;
  trackClick: (
    eventName: string,
    additionalTrackingData: {
      // eslint-disable-next-line camelcase
      ui_position: string;
    },
  ) => void;
  onUpsellRequest: (
    referrer: KnownReferrer,
    additionalTrackingData?: {
      // eslint-disable-next-line camelcase
      ui_position: string;
    },
  ) => void;
}

export const QuerySection = ({
  currentFunnelQuery,
  stepsWithError,
  showReducedUi,
  setCurrentFunnelQuery,
  trackClick,
  onUpsellRequest,
}: QuerySectionProps): JSX.Element => {
  const contextOfUse: ContextOfUse = {
    productType: ProductType.Analytics,
    page: 'funnels',
    toolName: 'Funnels',
  };

  return (
    <div>
      <FunnelSteps
        stepsWithError={stepsWithError}
        stepSeriesList={currentFunnelQuery.steps}
        onStepSeriesListUpdate={(stepSeriesList: StepSeries[], dateRange?: DateRange) =>
          setCurrentFunnelQuery({
            ...currentFunnelQuery,
            dateRange: dateRange ?? currentFunnelQuery.dateRange,
            steps: stepSeriesList,
          })
        }
        dateRange={currentFunnelQuery.dateRange}
        onUpsellRequest={onUpsellRequest}
        trackClick={trackClick}
        showReducedUi={showReducedUi}
        contextOfUse={contextOfUse}
      />
      {!showReducedUi && (
        <GlobalFilterSection
          currentFunnelQuery={currentFunnelQuery}
          setCurrentFunnelQuery={setCurrentFunnelQuery}
          onUpsellRequest={onUpsellRequest}
          trackClick={trackClick}
          contextOfUse={contextOfUse}
        />
      )}
    </div>
  );
};
